import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UploadArtwork from '../Images/UploadArtwork.png';

const HistoryOrder = ({ token }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedRow, setExpandedRow] = useState(null);
  const [reorderMessage, setReorderMessage] = useState("");
  const [showReorderPopup, setShowReorderPopup] = useState(false);
 
  const navigate = useNavigate();

  useEffect(() => {
    const fetchHistoryOrder = async () => {
      try {
        const response = await fetch("https://backend.printtrio.co.uk/api/order/history", {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();

        if (data.success && data.data) {
          setOrders(data.data || []);
        } else {
          setOrders([]);
        }
      } catch (err) {
        setError("An error occurred while fetching orders.");
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchHistoryOrder();
    }
  }, [token]);

  const handleShopNowClick = () => {
    navigate("/");
  };

  const toggleExpandRow = (id) => {
    setExpandedRow(expandedRow === id ? null : id);
  };

  const handleReorder = async (itemId) => {
    try {
      const response = await fetch(`https://backend.printtrio.co.uk/api/order/reorder-history-order/${itemId}`, {
        method: "GET", // Assuming the API expects a POST request
        headers: {
          "Accept": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
  
      if (data.success) {
        setReorderMessage("Your item was successfully re-added to the cart!");
        setShowReorderPopup(true);
      } else {
        console.error("Failed to reorder:", data.errors || "Unknown error");
      }
    } catch (err) {
      console.error("Error reordering item:", err);
    }
  };
  

  if (loading) {
    return (
      <div className="flex-grow p-10 bg-white mt-[3%] mb-[3%] mx-[5%] text-center py-10">
        Loading orders...
      </div>
    );
  }

  if (error) {
    return <div className="text-center py-10 text-red-500">{error}</div>;
  }

  // if (orders.length === 0) {
  //   return (
  //     <div className="flex flex-col justify-center items-center text-center">
  //       <p className="text-gray-500 text-sm mb-6">
  //         You don’t have any order history yet. Start shopping now to create your first order!
  //       </p>
  //       <button
  //         className="bg-transparent text-[#EC008C] font-semibold border-2 border-[#EC008C] rounded-full px-6 py-3 hover:bg-[#EC008C] hover:text-white transition duration-300 flex items-center gap-2"
  //         onClick={handleShopNowClick}
  //       >
  //         Shop Now
  //         <svg
  //           xmlns="http://www.w3.org/2000/svg"
  //           className="h-5 w-5"
  //           fill="none"
  //           viewBox="0 0 24 24"
  //           stroke="currentColor"
  //           strokeWidth={2}
  //         >
  //           <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
  //         </svg>
  //       </button>
  //     </div>
  //   );
  // }

  return (
    <div className="flex-grow p-10 bg-white mt-[3%] mb-[3%] mx-[5%] rounded-md overflow-x-auto">
    {orders.length === 0 ? (
      // No Orders Found View
      <div className="flex items-center justify-center min-h-[50vh] w-full">
      <div className="text-center">
        <p className="text-gray-500 text-sm mb-6">
        You don’t have any order history yet. Start shopping now to create your first order!
        </p>
        <button
          className="bg-transparent text-[#EC008C] font-semibold border-2 border-[#EC008C] rounded-full px-6 py-3 hover:bg-[#EC008C] hover:text-white transition duration-300 flex items-center gap-2 mx-auto"
          onClick={handleShopNowClick}
        >
          Shop Now
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
    
    
    ) : (
      <div className="">
                <table className="w-full border-separate border-spacing-y-0">

          <thead>
            <tr className="bg-white text-left">
              <th className="py-2 px-4">No</th>
              <th className="py-2 px-4">Created Date</th>
              <th className="py-2 px-4">Item</th>
              <th className="py-2 px-4">Price</th>
              <th className="py-2 px-4">Status</th>
              <th className="py-2 px-4 text-right">
                <span className="inline-block w-4 h-4"></span>
              </th>
            </tr>
          </thead>
          <tbody>
          {orders.map((order, idx) => {
              const isExpanded = expandedRow === order.id;
              const orderId = order.id;
              const createdDate = order.created_at ? new Date(order.created_at).toLocaleString() : "N/A";
              const itemCount = order.order_items.length || 1;
              const totalPriceValue = Number(order.total_price) || 0;
              const status = order.status;

              return (
                <React.Fragment key={order.id}>
                  {/* Main Row */}
                  <tr className={`text-left ${isExpanded ? "bg-[#F1F8FE]" : "bg-[#F1F8FE]"} rounded-md`}>
                    <td className="py-4 px-4 align-middle font-medium">{`#${orderId}`}</td>
                    <td className="py-4 px-4 align-middle whitespace-nowrap">{createdDate}</td>
                    <td className="py-4 px-4 align-middle">{itemCount} Item{itemCount > 1 ? 's' : ''}</td>
                    <td className="py-4 px-4 align-middle">£{totalPriceValue.toFixed(2)}</td>
                    <td className="py-4 px-4 align-middle">
                      <span className="text-[#EC008C] font-semibold">{status}</span>
                    </td>
                    <td className="py-4 px-4 align-middle text-right">
  <button onClick={() => toggleExpandRow(order.id)}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
      className={`h-5 w-5 inline-block transform transition-transform ${
        isExpanded ? 'rotate-180' : ''
      }`}
      fill="none"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 10l7 7 7-7"
      />
    </svg>
  </button>
</td>
                  </tr>

                  {/* Expanded Details Row */}
                  {isExpanded && (
                    <tr className="bg-[#F1F8FE] rounded-md">
                      <td colSpan="8" className="p-4">
                      {order.order_items.map((item, idx) => {
  const isSample = item.is_free_sample === 1;
  const display = isSample ? item.free_sample : item.product;
  const file1 = item.file1;
  const isLastItem = idx === order.order_items.length - 1;
  const total_price = item.total_price_with_vat;
  const price = isSample
  ? parseFloat(item.free_sample.price)
  : parseFloat(item.total_price_with_vat || 0);


  return (
    <React.Fragment key={item.id || idx}>
      <div className="flex justify-between items-center gap-4 mb-5 mt-5">
        <div className="flex gap-4">
          {/* IMAGE */}
          <img
            src={
              isSample
                ? `https://backend.printtrio.co.uk/${display.image}`
                : (file1 && typeof file1 === "string" && file1.trim() !== ""
                    ? file1
                    : UploadArtwork)
            }
            alt={display?.name || "Sample"}
            className="w-24 h-24 rounded-md object-contain"
          />

          {/* DETAILS */}
          <div className="text-sm text-gray-700 space-y-1">
            {isSample ? (
              <>
                <p className="mt-9"><strong>{display.name}</strong></p>
                {/* <p className="max-w-sm">{display.description}</p> */}
              </>
            ) : (
              <>
                <p><strong>Product:</strong> {display?.name}</p>
                {item.size && <p><strong>Size:</strong> {item.size}</p>}
                {item.paper_weight && <p><strong>Paper Weight:</strong> {item.paper_weight}</p>}
                {item.quantity && <p><strong>Quantity:</strong> {item.quantity}</p>}
                {item.service_description && (
                  <p className="max-w-sm"><strong>Service Description:</strong> {item.service_description}</p>
                )}

                {/* extra options */}
                {item.foiling_color && (
                  <p><strong>Foiling Color:</strong> {item.foiling_color}</p>
                )}
                {item.spot_UV != null && (
                  <p><strong>Spot UV:</strong> {item.spot_UV ? 'Yes' : 'No'}</p>
                )}
                {item.white_color != null && (
                  <p><strong>White Color:</strong> {item.white_color ? 'Yes' : 'No'}</p>
                )}
                {item.lamination && (
                  <p><strong>Lamination:</strong> {item.lamination}</p>
                )}
                {item.corner_cut_style && (
                  <p><strong>Corner Cut Style:</strong> {item.corner_cut_style}</p>
                )}
                {item.orientation && (
                  <p><strong>Orientation:</strong> {item.orientation}</p>
                )}
                {item.printed_side && (
                  <p><strong>Printed Side:</strong> {item.printed_side}</p>
                )}
                {item.paper_type && (
                  <p><strong>Paper Type:</strong> {item.paper_type}</p>
                )}
              </>
            )}
          </div>
        </div>

        {/* PRICE & REORDER BUTTON */}
        <div className="flex flex-col text-right text-black font-semibold">
        <span>
            Price: £{price.toLocaleString("en-GB", { minimumFractionDigits: 2 })}
          </span>
          <button
            className="mt-2 px-4 py-2 border-2 border-[#EC008C] text-[#EC008C] rounded-full text-xs font-semibold hover:bg-[#EC008C] hover:text-white transition duration-300"
            onClick={() => handleReorder(item.id)}
          >
            Reorder this item
          </button>
        </div>
      </div>

      {/* separator */}
      {!isLastItem && <hr />}
    </React.Fragment>
  );
})}



                      </td>
                    </tr>
                  )}
 {/* ───── SPACER BETWEEN ORDERS ───── */}
 {idx < orders.length - 1 && (
          <tr>
            <td colSpan="6" className="p-0 bg-white">
              <div className="h-4" />
            </td>
          </tr>
        )}
                  
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
       )}
       {showReorderPopup && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-6 rounded shadow-lg text-center">
      <p className="mb-4">{reorderMessage}</p>
      <button
        className="px-4 py-2 bg-[#EC008C] text-white rounded"
        onClick={() => setShowReorderPopup(false)}
      >
        Close
      </button>
    </div>
  </div>
)}

    </div>
  );
};

export default HistoryOrder;
